import SectionCard from "./SectionCard";
import CodeEditorPanel from "./CodeEditorPanel";

interface Props {
  value: string;
  onChange: (value: string) => void;
  onFormat: () => void;
  /** Locked while a save is in progress. */
  disabled?: boolean;
}

const AdditionalSettingsCard = ({
  value,
  onChange,
  onFormat,
  disabled = false,
}: Props) => (
  <SectionCard title="Additional Settings" collapsible defaultExpanded={false}>
    <CodeEditorPanel
      mode="json"
      value={value}
      onChange={onChange}
      readOnly={disabled}
      height="150px"
      showLineNumbers={false}
      onFormat={onFormat}
      formatDisabled={!value || disabled}
    />
  </SectionCard>
);

export default AdditionalSettingsCard;
